import {Component, EventEmitter, Output} from '@angular/core';
import {TraductionService} from './traduction.service';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AlertService} from '../alert/alert.service';
import {AbstractSigaleComponent} from '../abstract-sigale.component';
import {ToastModule} from 'primeng/toast';
import {MessageService} from 'primeng/api';
import { ButtonModule } from 'primeng/button';

@Component({
	standalone: true,
	selector: 'traduction',
	templateUrl: './traduction.component.html',
	styleUrls: ['./traduction.component.scss'],
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		ToastModule,
		ButtonModule
	]
})
export class TraductionComponent extends AbstractSigaleComponent {

	@Output('onSuccess')
	onSuccess: EventEmitter<string> = new EventEmitter();

	constructor(private traductionService: TraductionService, private alertService: AlertService, private messageService: MessageService) {
		super();
	}

	/**
	 * Peupler
	 */
	peuplerCacheTraduction(): void {
		this.alertService.clear();
		this.traductionService.peupler().subscribe(
				() => {
					this.afficherToastSuccess();
					this.onSuccess.emit();
				}, erreur => {
					this.alertService.error(erreur.error, this.nomAlert);
				}
		);
	}

	public afficherToastSuccess(): void {
		this.messageService.add({severity: 'success', detail: this.translateService.instant('SIGALE_ANGULAR.COMPONENTS.TRADUCTION.OPERATION_REUSSIE')});
	}

	traductionFR(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"TRADUCTION": {
						"SUCCES": "Opération réussie",
						"TITRE_LEGEND": "Diffusion des éléments à traduire",
						"MESSAGE_DIFFUSION": "Ceci permet de diffuser à l'application SigaleTraduction les éléments à traduire.",
						"TITLE_BTN_DIFFUSION": "Diffuse les éléments traduisibles à l'application Traduction",
						"BTN_DIFFUSER": "Diffuser les éléments traduisibles",
						"TITRE_RECHARGER_LEGEND": "Récupération des éléments traduits",
						"MESSAGE_RECHARGER": "Ceci permet de remplir le cache avec les caractéristiques traduites",
						"TITLE_BTN_RECHARGER": "Rempli le cache avec les caractéristiques traduites",
						"BTN_RECHARGER_CACHE": "Recharger le cache des traductions",
						"OPERATION_REUSSIE": "Opération réussie"
					}
				}
			}
		};
	}


	traductionIT(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"TRADUCTION": {
						"SUCCES": "Operazione riuscita",
						"TITRE_LEGEND": "Diffusione degli elementi da tradurre",
						"MESSAGE_DIFFUSION": "Questo permette di inviare all'applicazione SigaleTraduzione gli elementi da tradurre.",
						"TITLE_BTN_DIFFUSION": "Invia gli elementi traducibili all'applicazione Traduzione",
						"BTN_DIFFUSER": "Inviare gli elementi traducibili",
						"TITRE_RECHARGER_LEGEND": "Recuperare gli elementi tradotti",
						"MESSAGE_RECHARGER": "Questo permette di riempire la memoria con le caratteristiche tradotte",
						"TITLE_BTN_RECHARGER": "Riempire la memoria con le caratteristiche tradotte",
						"BTN_RECHARGER_CACHE": "Ricaricare la memoria delle traduzioni",
						"OPERATION_REUSSIE": "Operazione riuscita"
					}
				}
			}
		};
	}
}
